import { useTranslation } from "react-i18next";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { DeleteForever, EditOutlined, RemoveRedEye } from "@mui/icons-material";
import { removeHTMLTags } from "utils/removeHTMLTags";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";

const PopupTable = (transactions = [], methods = {}) => {
  const { t, i18n } = useTranslation();
  const { openModal, handleView } = methods;
  const navigate = useNavigate();

  const columns = [
    { field: "id", headerName: "#", width: 80 },
    // { field: "title", headerName: t("fields.title"), width: 250 },
    {
      field: "title",
      headerName: t("fields.title"),
      width: 250,
      renderCell: (params) => (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
          dangerouslySetInnerHTML={{ __html: params.row.title }}
        />
      ),
    },

    { field: "subTitle", headerName: t("fields.subtitle"), width: 250 },
    // { field: 'Content', headerName: t("fields.content"), width: 350 },
    {
      field: "Content",
      headerName: t("fields.content"),
      width: 350,
      renderCell: (params) => (
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
          }}
          dangerouslySetInnerHTML={{ __html: params.row.Content }}
        />
      ),
    },

    { field: "ButtonName", headerName: t("fields.button_name"), width: 250 },
    {
      field: "Link",
      headerName: t("fields.link"),
      width: 250,
      renderCell: (props) => {
        const links = props.row.Link;
        if (!Array.isArray(links) || links.length === 0) {
          return <Typography>No links available</Typography>;
        }

        return (
          <div>
            {links.map((link, index) => (
              <div key={index}>
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ wordBreak: "break-word" }}
                >
                  {link}
                </a>
              </div>
            ))}
          </div>
        );
      },
    },

    {
      field: "Atachment",
      headerName: t("fields.atachment"),
      width: 250,
      renderCell: (props) => {
        const media = props.row.media;
        const imageUrl = media && media.length > 0 ? media[0] : null;
        return imageUrl ? (
          <img
            src={imageUrl}
            alt="Attachment"
            style={{
              width: 80,
              height: 50,
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        ) : (
          <Typography>No Attachment</Typography>
        );
      },
    },
    {
      field: "Type",
      headerName: t("fields.type_popup"),
      width: 250,
      renderCell: (props) => {
        const type = props.row.Type;
        const typeStyle = {
          backgroundColor: "#E0E0E0",
          padding: "5px 10px",
          borderRadius: "5px",
          fontWeight: "bold",
          textAlign: "center",
          fontSize: "14px",
          textTransform: "capitalize",
        };
        return <Typography style={typeStyle}>{type}</Typography>;
      },
    },
    {
      field: "Actions",
      headerName: t("fields.actions"),
      width: 250,
      sortable: false,
      renderCell: (props) => {
        const rowId = props.row._id;
        const lang = i18n.language || "en";

        return (
          <Grid container spacing={1} justifyContent="center">
            <Grid item>
              <Tooltip title="View" arrow>
                <IconButton
                  size="small"
                  onClick={() =>
                    navigate(`/${lang}/admin/view-details-popup/${rowId}`)
                  }
                >
                  <RemoveRedEye fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item>
              <Tooltip title="Edit" arrow>
                <IconButton
                  size="small"
                  onClick={() => navigate(`/${lang}/admin/edit-popup/${rowId}`)}
                >
                  <EditOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item>
              <Tooltip title="Delete" arrow>
                <IconButton size="small" onClick={() => openModal(rowId)}>
                  <DeleteForever fontSize="small" />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        );
      },
    },
  ];

  const rows =
    transactions.length === 0
      ? []
      : [
          ...transactions.reverse().map((transaction, index) => ({
            id: index + 1,
            // title: removeHTMLTags(transaction["title_en"]),
            title: DOMPurify.sanitize(transaction["title_en"]),
            subTitle: removeHTMLTags(transaction["sub_title_en"] || ""),
            Content: DOMPurify.sanitize(transaction["body_en"]),
            // Content: removeHTMLTags(transaction["body_en"]),
            ButtonName: transaction["button_en"],
            Link: Array.isArray(transaction["link"]) ? transaction["link"] : [],

            Type: transaction["type"],
            media: transaction["media"],
            _id: transaction._id,
          })),
        ];

  return { rows, columns };
};

export default PopupTable;
